import { t } from "i18next";
import { cn, getFloorName } from "@/lib/utils";
import { PiArrowUpLight, PiArrowDownLight } from "react-icons/pi";
import { FaPhone } from "react-icons/fa6";
import Globe from "@/assets/globe-white.svg";

import useMapStore from "@/store/mapStore";
import PoiDetailsRouteProgress from "./PoiDetailsRouteProgress";

function PoiDetailsSpecs() {
  const haveRouteDetails = useMapStore((state) => state.haveRouteDetails);
  const haveRoutePreview = useMapStore((state) => state.haveRoutePreview);
  const routeDetails = useMapStore((state) => state.routeDetails);
  const currentLanguage = useMapStore((state) => state.currentLang);
  const floors = useMapStore((state) => state.floors);
  const kioskMode = useMapStore((state) => state.kioskMode);
  // const activeKiosk = useMapStore((state) => state.activeKiosk);
  const mobileMode = useMapStore((state) => state.mobileMode);
  let poi = useMapStore((state) => state.routeFinish);
  const activeStop = useMapStore((state) => state.activeStop);
  const stops = useMapStore((state) => state.stops);

  if (stops.length > 2 && stops[activeStop]?.feature) {
    poi = stops[activeStop].feature!;
  }

  const getUrl = () => {
    if (poi?.properties) {
      if (poi.properties.url_i18n && poi.properties.url_i18n[currentLanguage]) {
        return poi.properties.url_i18n[currentLanguage];
      }
      if (poi.properties.url) {
        return poi.properties.url;
      }
      if (poi.properties.metadata?.url) {
        return poi.properties.metadata.url;
      }
    }
  };

  return (
    <>
      {!haveRouteDetails && (
        <ul className="mt-2 flex gap-3">
          {poi?.properties?.contact &&
            poi?.properties?.contact.length > 0 &&
            poi?.properties?.contact !== "TBA" && (
              <li className="mb-2 inline-flex flex-1 items-center justify-center gap-2 rounded-full border border-primary px-1 py-2">
                <FaPhone className="text-primary" />
                <span className="text-sm">
                  {mobileMode ? (
                    <a href={`tel:${poi?.properties.contact}`}>
                      {t("call-store")}
                    </a>
                  ) : (
                    <span dir="ltr">{poi?.properties.contact}</span>
                  )}
                </span>
              </li>
            )}
          <li
            className={cn(
              "mb-2 inline-flex",
              poi?.properties?.contact &&
                poi?.properties?.contact.length > 0 &&
                poi?.properties?.contact !== "TBA" &&
                "flex-1",
            )}
          >
            {!kioskMode && getUrl() && (
              <a
                href={getUrl()}
                target="_parent"
                className={cn(
                  "flex items-center justify-center gap-2 rounded-full border border-primary bg-primary px-4 py-2 text-sm text-white lg:hover:bg-primary/70",
                  poi?.properties?.contact &&
                    poi?.properties?.contact.length > 0 &&
                    poi?.properties?.contact !== "TBA" &&
                    "flex-1 px-1",
                )}
              >
                <img src={Globe} alt="Globe" className="-mt-0.5" />
                {t("check-website")}
              </a>
            )}
          </li>
        </ul>
      )}
      {(haveRoutePreview || haveRouteDetails) && (
        <ul
          className={cn(
            "my-5 flex flex-col gap-2 text-sm lg:gap-1 lg:text-base",
            haveRouteDetails && "mt-0",
            haveRouteDetails && mobileMode && "my-1.5",
          )}
        >
          {/*haveRoutePreview && !haveRouteDetails && (
            <li className="flex items-center gap-2">
              <FaLocationCrosshairs className="text-lg text-primary" />
              <span>
                {t("you-are-on")}{" "}
                <strong>
                  {getFloorName({
                    floor:
                      kioskMode && activeKiosk
                        ? floors.find((f) => f.level === activeKiosk.level)!
                        : floors.find(
                            (f) =>
                              f.id === routeDetails.start?.properties?.floor_id,
                          )!,
                    language: currentLanguage,
                  })}{" "}
                  {t("floor").toLowerCase()}
                </strong>
              </span>
            </li>
          )*/}
          {haveRoutePreview &&
            !haveRouteDetails &&
            routeDetails.start?.properties?.level !==
              routeDetails.end?.properties?.level && (
              <li className="flex items-center gap-2">
                {routeDetails.start?.properties?.level <
                routeDetails.end?.properties?.level ? (
                  <PiArrowUpLight className="text-lg text-primary" />
                ) : (
                  <PiArrowDownLight className="text-lg text-primary" />
                )}
                <span>
                  {routeDetails.start?.properties?.level <
                  routeDetails.end?.properties?.level
                    ? t("ascend")
                    : t("descend")}{" "}
                  <strong>
                    {Math.abs(
                      routeDetails.start?.properties?.level -
                        routeDetails.end?.properties?.level,
                    )}{" "}
                    {Math.abs(
                      routeDetails.start?.properties?.level -
                        routeDetails.end?.properties?.level,
                    ) > 1
                      ? t("floors")
                      : t("floor").toLowerCase()}{" "}
                    {`${t("to")} ${getFloorName({
                      floor: floors.find(
                        (f) => f.level === routeDetails.end?.properties.level,
                      )!,
                      language: currentLanguage,
                    })}`}{" "}
                    {t("floor").toLowerCase()}
                  </strong>
                </span>
              </li>
            )}
          {haveRoutePreview && (
            <li className="flex items-center gap-2">
              <PoiDetailsRouteProgress />
            </li>
          )}
        </ul>
      )}
    </>
  );
}

export default PoiDetailsSpecs;
